import appService from '../js/appservice/index'
import { getErrorMessage } from '../js/helpers/storehelper'
import funcs from '../js/helpers/misc'

const state = {
  testMethods: [],
  activeStandardTestMethods: [],
  activeCustomerTestMethods: [],
  currentTestMethod: {},
  questionFormats: [],
  pdfTypes: [],
  currentTestMethodScales: [],
  currentNormGroups: [],
  currentNormGroup: {},
  currentNormScales: []
}

const getters = {
  testMethods: state => state.testMethods,
  activeStandardTestMethods: state => state.activeStandardTestMethods,
  activeCustomerTestMethods: state => state.activeCustomerTestMethods,
  currentTestMethod: state => state.currentTestMethod,
  questionFormats: state => state.questionFormats,
  pdfTypes: state => state.pdfTypes,
  currentTestMethodScales: state => state.currentTestMethodScales,
  currentNormGroups: state => state.currentNormGroups,
  currentNormGroup: state => state.currentNormGroup,
  currentNormScales: state => state.currentNormScales
}

const actions = {
  getTestMethod(context, data) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getTestMethod(data.testMethodId, data.languageId)
        .then(data => {
          context.commit('getTestMethod', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addTestMethod(context, testMethod) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .addTestMethod(testMethod)
        .then(data => {
          context.commit('addTestMethod', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateTestMethod(context, testMethod) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .updateTestMethod(testMethod)
        .then(data => {
          context.commit('updateTestMethod', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateTestMethodQuestionsOrder(context, indata) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .updateTestMethodQuestionsOrder(indata.testMethodId, indata.postData)
        .then(data => {
          context.commit('updateTestMethod', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getAllTestMethods(context) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getAllTestMethods()
        .then(data => {
          context.commit('getAllTestMethods', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getActiveStandardTestMethods(context) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getActiveStandardTestMethods()
        .then(data => {
          context.commit('getActiveStandardTestMethods', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getActiveCustomerTestMethods(context) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getActiveStandardTestMethods()
        .then(data => {
          context.commit('getActiveCustomerTestMethods', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  selectTestMethod(context, testMethod) {
    context.commit('selectTestMethod', testMethod)
  },
  selectTestMethodScales(context, testMethodScales) {
    context.commit('getTestMethodScales', testMethodScales)
  },
  selectTestMethodNormGroups(context, testMethodNormGroups) {
    context.commit('getNormGroups', testMethodNormGroups)
  },
  selectTestMethodNormGroup(context, normGroup) {
    context.commit('setCurrentNormGroup', normGroup)
  },
  deleteTestMethod(context, testMethod) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .deleteTestMethod(testMethod)
        .then(() => {
          context.commit('deleteTestMethod', testMethod.id)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getTestMethodScales(context, testMethodId) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getTestMethodScales(testMethodId)
        .then(data => {
          context.commit('getTestMethodScales', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getQuestionFormats(context) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getQuestionFormats()
        .then(data => {
          window.sessionStorage.setItem(
            'getQuestionFormats',
            JSON.stringify(data)
          )
          context.commit('getQuestionFormats', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getPdfTypes(context) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getPdfTypes()
        .then(data => {
          window.sessionStorage.setItem('getPdfTypes', JSON.stringify(data))
          context.commit('getPdfTypes', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getNormGroups(context, indata) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getNormGroups(indata.testMethodId, indata.languageId)
        .then(data => {
          context.commit('getNormGroups', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  saveNormGroup(context, indata) {
    if (indata.normGroup.id) {
      return new Promise((resolve, reject) => {
        appService.testmethods
          .updateNormGroup(indata.testMethodId, indata.normGroup)
          .then(data => {
            context.commit('saveNormGroup', data)
            resolve()
          })
          .catch(error => {
            reject(getErrorMessage(error))
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        appService.testmethods
          .addNormGroup(indata.testMethodId, indata.normGroup)
          .then(data => {
            context.commit('saveNormGroup', data)
            resolve(data)
          })
          .catch(error => {
            reject(getErrorMessage(error))
          })
      })
    }
  },
  deleteNormGroup(context, indata) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .deleteNormGroup(indata.testMethodId, indata.normGroupId)
        .then(() => {
          context.commit('deleteNormGroup', indata.normGroupId)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getNormScales(context, indata) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .getNormScales(
          indata.testMethodId,
          indata.languageId,
          indata.defaultLanguageId
        )
        .then(data => {
          context.commit('getNormScales', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateNormScales(context, indata) {
    return new Promise((resolve, reject) => {
      appService.testmethods
        .updateNormScales(
          indata.testMethodId,
          indata.normScaleIds,
          indata.languageId,
          indata.defaultLanguageId,
          indata.doRandomize
        )
        .then(data => {
          context.commit('updateNormScales', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}

const mutations = {
  getTestMethod(state, data) {
    state.currentTestMethod = data
  },
  addTestMethod(state, data) {
    state.testMethods.push(data)
    state.currentTestMethod = data
  },
  updateTestMethod(state, data) {
    state.currentTestMethod = data
  },
  deleteTestMethod(state, data) {
    var index = funcs.getIndexInCollection('id', data, state.testMethods)
    if (index !== -1) {
      state.testMethods.splice(index, 1)
    }
  },
  getTestMethodScales(state, data) {
    state.currentTestMethodScales = data
  },
  getAllTestMethods(state, data) {
    state.testMethods = data
  },
  getActiveStandardTestMethods(state, data) {
    state.activeStandardTestMethods = data
  },
  getActiveCustomerTestMethods(state, data) {
    state.activeCustomerTestMethods = data
  },
  selectTestMethod(state, data) {
    state.currentTestMethod = data
  },
  getQuestionFormats(state, data) {
    state.questionFormats = data
  },
  getPdfTypes(state, data) {
    state.pdfTypes = data
  },
  getNormGroups(state, data) {
    state.currentNormGroups = data
  },
  setCurrentNormGroup(state, data) {
    state.currentNormGroup = data
  },
  saveNormGroup(state, data) {
    data.normScaleValues.forEach(values => {
      state.currentNormGroup.normScaleValues.forEach(innerValues => {
        if (values.scaleId === innerValues.scaleId) {
          values.scaleName = innerValues.scaleName
        }
      })
    })

    var index = funcs.getIndexInCollection(
      'id',
      data.id,
      state.currentNormGroups
    )
    if (index === -1) {
      state.currentNormGroups.push(data)
    } else {
      state.currentNormGroups[index] = data
    }

    state.currentNormGroup = data
  },
  deleteNormGroup(state, data) {
    var index = funcs.getIndexInCollection('id', data, state.currentNormGroups)
    if (index !== -1) {
      state.currentNormGroups.splice(index, 1)
    }
  },
  getNormScales(state, data) {
    state.currentNormScales = data
  },
  updateNormScales(state, data) {
    state.currentNormScales = data
  }
}

if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function(event) {
    let formats = window.sessionStorage.getItem('getQuestionFormats')
    let pdfs = window.sessionStorage.getItem('getPdfTypes')
    if (formats && formats.length > 0) {
      state.questionFormats = JSON.parse(formats)
    }
    if (pdfs && pdfs.length > 0) {
      state.pdfTypes = JSON.parse(pdfs)
    }
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
